import { MediaObserver } from '@angular/flex-layout';
import { Component, Input, OnInit } from '@angular/core';
import { MatSlideToggleChange, MatSlideToggleModule } from '@angular/material/slide-toggle';
import { AccountService } from 'src/app/pages/account/services/account.service';
import { FundraiserService } from '../../../services/fundraiser.service';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { AddOfflineDonationComponent } from '../../dialogs/offline-donations/add-offline-donation/add-offline-donation.component';
import { ViewSummaryComponent } from '../../dialogs/offline-donations/view-summary/view-summary.component';
import { MatButtonModule } from '@angular/material/button';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FormsModule } from '@angular/forms';
import { NgIf, NgClass } from '@angular/common';
import { FlexModule } from '@angular/flex-layout/flex';

@Component({
    selector: 'app-donations-zero',
    templateUrl: './donations-zero.component.html',
    standalone: true,
    imports: [FlexModule, NgIf, MatSlideToggleModule, FormsModule, MatTooltipModule, NgClass, ExtendedModule, MatButtonModule]
})
/** *Donations Zero Component */
export class DonationsZeroComponent implements OnInit {
	@Input() isLoggedInUserAdmin: boolean = false;
	@Input() hideToggleSwitch = false;
	@Input() donationReceivedBoolean!: boolean;
	@Input() isLoggedIn: any;
	@Input() currentFundraiser: any;
	@Input() isDraftOrClosed: boolean = false;
	@Input() isWholePreview!: boolean;

	showDonorList: boolean = true; // default value of toggle
	tooltip = $localize`:@@donor_list_hide_tooltip: Turn the toggle off to hide donation details on the public fundraiser page`;
	offlineDonationTooltip = $localize`:@@donor_list_offlinedonation_tooltip: This will allow you to add donation collected offline by the cause`;
	viewSummaryTooltip = $localize`:@@donor_list_view_summary_tooltip: Add offline donations to see summary`;
	addOfflineDonationTooltip = $localize`:@@donor_list_add_offline_donation_tooltip: Publish your fundraiser before adding offline donation`;
	totalOfflineDonationAmount: any;
	offlineDonationCount: any;
	isViewSummary: boolean = true;
	currency_symbol: any;
	slug: any;

	constructor(
		public _media: MediaObserver,
		public dialog: MatDialog,
		private _accountService: AccountService,
		private fundraiserService: FundraiserService,
		public notificationService: NotificationService,
		public router: Router
	) {}

	ngOnInit(): void {
		this.showDonorList = this.donationReceivedBoolean;
		this.slug = this.router.url.split('?')[0].substring(13);
		this.getOfflineDonations();
		this.fundraiserService.getOfflineDonation().subscribe((res) => {
			this.getOfflineDonations();
		});
	}
	/** *Function responsible for toggling between hide and show donor list */
	onToggleChange(event: MatSlideToggleChange) {
		this.showDonorList = event.checked;
		const toggleValue = { show_donor_list: this.showDonorList };
		if (this._accountService.checkHeaders()) {
			this.fundraiserService
				.showDonationList({
					show_donations: this.showDonorList,
					slug: this.slug,
				})
				.subscribe((res) => {
					this.notificationService.openNotification(
						$localize`:@@donor_list_hidden_change_notification: Donor list details change is saved`,
						'',
						'success'
					);
					window.location.reload();
				},
				(error) => {
				  this.notificationService.openNotification(
					$localize`:@@donor_list_hidden_change_error:An error occurred while saving donor list details`,
					'Ok',
					'error'
				  );
				});
		}
	}

	addOfflineDonation(): void {
		this.dialog.open(AddOfflineDonationComponent, {
			maxHeight: '98vh',
			data: {
				slug: this.slug,
				currency_symbol: this.currentFundraiser.currency_symbol,
				currency_code: this.currentFundraiser.currency_code,
			},
		});
	}

	viewOfflineDonationSummary(): void {
		this.dialog.open(ViewSummaryComponent, {
			data: {
				slug: this.slug,
				isLoggedIn: this.isLoggedIn,
				isLoggedInUserAdmin: this.isLoggedInUserAdmin,
			},
		});
	}

	getOfflineDonations() {
		const slug = this.slug;
		if (slug) {
			this.fundraiserService
				.getAllOfflineDonation(this.slug)
				.subscribe((res: any) => {
					this.totalOfflineDonationAmount = Number(
						res.data.result.total_amount
					);
					this.currency_symbol = this.currentFundraiser.currency_symbol;
					this.offlineDonationCount = res.data.result.details.length;
					this.isViewSummary = this.offlineDonationCount !== 0;
				});
		}
	}
}
